<template>
  <div>
    <el-table :data="orderList"  size="small" border>
      <el-table-column prop="userId" width="80px" label="用户ID" fixed>
        <template slot-scope="scope">
          <span>{{ scope.row.userId }}</span>
         
        </template>
      </el-table-column>
      <el-table-column prop="orderId"  label="订单号" width="150" fixed>
        <template slot-scope="scope">{{
          scope.row.orderId
        }}</template>
      </el-table-column>
      <el-table-column prop="createdTime"  label="创建时间" width="140" fixed>
        <template slot-scope="scope">{{
          new Date(scope.row.createdTime).toLocaleString()
        }}</template>
      </el-table-column>
      <el-table-column prop="symbolId"  label="币种Id" >
        <template slot-scope="scope">
          <span v-if="scope.row.symbolId">{{scope.row.symbolId}}</span>
          <span v-else>--</span>
          
        </template>
      </el-table-column>
      <el-table-column prop="orderType"  label="订单类型" >
        <template slot-scope="scope">
          <span v-if="scope.row.orderType==1">限价单</span>
          <span v-else>市价单</span>
        </template>
      </el-table-column>
      <el-table-column prop="orderSide"  label="下单方向" >
        <template slot-scope="scope">
          <span v-if="scope.row.orderSide==1">买入</span>
          <span v-else>卖出</span>
        </template>
      </el-table-column>
      <el-table-column prop="timeInForce"  label="有效方式" fixed>
        <template slot-scope="scope">
          <span v-if="scope.row.timeInForce==1">GTC</span>
          <span v-else-if="scope.row.timeInForce==2">FOK</span>
          <span v-else-if="scope.row.timeInForce==3">IOC</span>
          <span v-else>GTX</span>
        </template>
      </el-table-column>
      <el-table-column prop="price" label="价格" ></el-table-column>
      <el-table-column prop="origQty" label="数量" ></el-table-column>
      <el-table-column prop="marginFrozen" label="冻结资金" ></el-table-column>
      <el-table-column prop="avgPrice" label="均价" ></el-table-column>
      <el-table-column prop="executedQty" label="已成交数量" ></el-table-column>
      <el-table-column prop="cumQuote" label="成交额" ></el-table-column>

      <el-table-column prop="state"  label="订单状态" >
        <template slot-scope="scope">
          <span v-if="scope.row.state==1">新建</span>
          <span v-else-if="scope.row.state==2">部分成交</span>
          <span v-else-if="scope.row.state==3">全部成交</span>
          <span v-else-if="scope.row.state==4">用户撤销</span>
          <span v-else-if="scope.row.state==5">下单失败</span>
          <span v-else-if="scope.row.state==6">已过期</span>
          <span v-else>GTX</span>
        </template>
      </el-table-column>


      
     
      <!-- <el-table-column label="编辑" fixed="right" width="120" align="center">
        <template slot-scope="scope">
          <el-button
            size="mini"
            type="primary"
            icon="el-icon-edit"
            circle
            @click="handleUpdate(scope.row)"
          ></el-button>
          <el-button
            size="mini"
            type="danger"
            icon="el-icon-delete"
            circle
            @click="handleDel(scope.row)"
          ></el-button>
        </template>
      </el-table-column> -->
    </el-table>
    <pagination
      :size="size"
      :total="totalCount"
      :page="page"
      @pageChanged="pageChanged"
    ></pagination>
    <!-- <update-dialog  :val="userinfoDetail"  :selected="queryValue" :page="page" :size="size"></update-dialog> -->
   
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState, mapMutations } from 'vuex';
import Pagination from 'components/pagination';


export default {
  name: 'FinanceOrderList',

  data() {
    return {
      page:1,size:25,
    };
  },
  components: {
    Pagination,
  },
  methods: {
    ...mapActions('financeOrder', [
      'updateDividendStatus',
      'updateMark'
    ]),
    ...mapMutations('financeOrder', [
      'setUserinfoDetailDialogVisible',
      'setUserinfoDetail'
    ]),
    pageChanged(e) {
      this.page=e.page
      this.size=e.size
      this.$emit('refresh', {page:this.page,size:this.size});
    },
    handleDel(row){
    },
    handleUpdate(selected) {
      this.setUserinfoDetail(selected);
      this.setUserinfoDetailDialogVisible(true);
    },
   
  },
  computed: {
    ...mapGetters('financeOrder', ['userList',]),
    ...mapState('financeOrder', [
      'pagination',
      'totalCount',
      'userinfoDetail',
      'userinfoDetailDialogVisible','blockInfoList','orderList'
    ])
  }
};
</script>

<style lang="less" scoped>
.user-type-select {
  width: 100%;
}
.red {
  color: red;
  font-weight: bold;
}
</style>
